export default [
  {
    path: "/pin-mode",
    component: () => import("@/views/business/pin/PinMode.vue"),
    meta: {
      hideNav: true,
      preventInit: true,
    },
  },
];
